import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import type { Locale } from '../api/types';
import { en } from './en';
import { zhTW } from './zh-TW';

export const LOCALES: readonly Locale[] = ['en', 'zh-TW'];
export const LOCALE_STORAGE_KEY = 'smoke.locale';

/** zh-TW when the browser prefers any Chinese, else en (FR-ACC-08). */
export function toLocale(lng: string | undefined | null): Locale {
  return lng?.toLowerCase().startsWith('zh') ? 'zh-TW' : 'en';
}

export function currentLocale(): Locale {
  return toLocale(i18n.resolvedLanguage ?? i18n.language);
}

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: { en: { translation: en }, 'zh-TW': { translation: zhTW } },
    supportedLngs: [...LOCALES],
    fallbackLng: 'en',
    load: 'currentOnly',
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: LOCALE_STORAGE_KEY,
      caches: ['localStorage'],
      convertDetectedLanguage: (lng: string) => toLocale(lng),
    },
    // React escapes interpolated values.
    interpolation: { escapeValue: false },
    returnNull: false,
  });

function syncHtmlLang(lng: string) {
  document.documentElement.lang = toLocale(lng);
}
syncHtmlLang(i18n.language);
i18n.on('languageChanged', syncHtmlLang);

export default i18n;
